import script from "./PacientesView.vue?vue&type=script&setup=true&lang=js"
export * from "./PacientesView.vue?vue&type=script&setup=true&lang=js"

import "./PacientesView.vue?vue&type=style&index=0&id=f5458102&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5458102"]])

export default __exports__